<template>
<div class="relative">
	<div class="fixed white" style="width: 100%" id="tool-bar">
	<v-row style="width: 100%" align="center" justify="start" class="ma-0">
		<v-col cols="12" sm="6" xs="6" md="12" lg="4">
			<slot name="breadcrumbs" :item="true"></slot>
		</v-col>
		<v-spacer></v-spacer>
	</v-row>
	<div v-if="$route.params.id" style="border-color: #f1f1f1 !important;" class="my-border rounded grey--text mx-4 px-3 mb-3  text-center text-wrap">
		<v-row class="my-0" align="center">
			<div v-if="$route.name == 'statement'" class="grey--text pa-3 text--title text-center font-weight-bold text-wrap">
				{{ $t('AccountStatementPage.account') }} 
				<bee-account-label emptyState="_" :bold="true" :color="$vuetify.theme.themes.light.blueGray" :account="accountStatement.account || null" ></bee-account-label>
				{{$t('AccountStatementPage.from-date')}}
				<bee-date-label emptyState="_" :color="$vuetify.theme.themes.light.blueGray" :bold="true" :date="accountStatement.start_date || null" ></bee-date-label>
				{{$t('AccountStatementPage.to-date')}}
				<bee-date-label emptyState="_" :color="$vuetify.theme.themes.light.blueGray" :bold="true" :date="accountStatement.end_date || null" ></bee-date-label>
			</div>
			<div v-if="routeNameIsMatchings" class="grey--text pa-3 text--title text-center font-weight-bold text-wrap">
				{{ $t('AccountStatementPage.account') }} 
				<bee-account-label emptyState="_" :bold="true" :color="$vuetify.theme.themes.light.blueGray" :account="accountStatement.account || null" ></bee-account-label>
				{{$t('AccountStatementPage.from-date')}}
				<bee-date-label emptyState="_" :color="$vuetify.theme.themes.light.blueGray" :bold="true" :date="configs.financial_file.start_date || null" ></bee-date-label>
				{{$t('AccountStatementPage.to-date')}}
				<bee-date-label emptyState="_" :color="$vuetify.theme.themes.light.blueGray" :bold="true" :date="configs.financial_file.end_date || null" ></bee-date-label>
			</div>
			<v-spacer class="d-sm-block d-none"></v-spacer>
			<v-col cols="auto" class="d-flex flex-wrap align-center">
				<!-- export -->
				<v-menu v-if="$route.name !== 'matchings'" offset-y>
					<template v-slot:activator="{ on }">
						<v-btn dark color="printingColor" class="px-2 me-2" v-on="on">
							<span class="d-flex align-center">
								<v-icon color="white">mdi-export-variant</v-icon>
								<span style="font-size: 14px">
									{{$t('AccountStatementPage.export')}}
								</span>
							</span>
						</v-btn>
					</template>

					<bee-list>
						<!-- excel -->
						<bee-list-item
							context="statement"
							:item="exportItems[0]"
							dense
							@click="exportAs('excel')"
						></bee-list-item>

						<!-- excel (brief) -->
						<bee-list-item
							context="statement"
							:item="exportItems[1]"
							dense
							@click="exportAs('excel', true)"
						></bee-list-item>

						<!-- pdf -->
						<bee-list-item
							context="statement"
							:item="exportItems[2]"
							dense
							@click="exportAs('pdf')"
						></bee-list-item>

						<!-- pdf (brief) -->
						<bee-list-item
							context="statement"
							:item="exportItems[3]"
							dense
							@click="exportAs('pdf', true)"
						></bee-list-item>
					</bee-list>
				</v-menu>

				<!-- export from latest matching -->
				<v-menu v-if="$route.name !== 'matchings'" offset-y>
					<template v-slot:activator="{ on }">
						<v-btn dark color="printingColor" class="px-2 me-2 my-sm-0 my-1" v-on="on">
							<span class="d-flex align-center">
								<v-icon color="white">mdi-export-variant</v-icon>
								<span style="font-size: 14px">
									{{$t('AccountStatementPage.export-from-latest-matching')}}
								</span>
							</span>
						</v-btn>
					</template>

					<bee-list>
						<!-- excel -->
						<bee-list-item
							context="statement"
							:item="exportItems[0]"
							dense
							@click="exportAs('excel', false, true)"
						></bee-list-item>

						<!-- excel (brief) -->
						<bee-list-item
							context="statement"
							:item="exportItems[1]"
							dense
							@click="exportAs('excel', true, true)"
						></bee-list-item>

						<!-- pdf -->
						<bee-list-item
							context="statement"
							:item="exportItems[2]"
							dense
							@click="exportAs('pdf', false, true)"
						></bee-list-item>

						<!-- pdf (brief) -->
						<bee-list-item
							context="statement"
							:item="exportItems[3]"
							dense
							@click="exportAs('pdf', true, true)"
						></bee-list-item>
					</bee-list>
				</v-menu>

				<bee-btn
					context="matching_table"
					:action-name="actions.GET"
					:icon="routeNameIsMatchings ? 'fa-arrow-circle-left' : ''"
					@click="!routeNameIsMatchings ? redirectToMatchingsPage() : goBack()"
					:content="!routeNameIsMatchings ? $t('AccountStatementPage.view-match-table') : $t('AccountStatementPage.back')"
					:color="!routeNameIsMatchings ? 'displayingColor' : 'blueGray'"
				></bee-btn>
			</v-col>
		</v-row>
	</div>
	<div v-if="!routeNameIsMatchings">
		<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
			<v-col cols="auto" lg="auto" md="3" sm="6" class="d-flex flex-column pe-lg-0" style="max-width: 25vw">
				<bee-account-autocomplete
					context="statement" 
					:action-name="actions.GET" 
					:label="$t('AccountStatementPage.account-num-or-name')"
					:items="configs.accounts"
					v-model="account_id"
					class="d-flex justify-start"
					:hide-details="true"
					:with-balance="true"
					ref="BeeAutocomplete"
					@keydown-enter-prevent="search()"
				></bee-account-autocomplete>
			</v-col>
			<v-col cols="auto" lg="2" md="auto" sm="6" class="pe-lg-0 d-flex flex-column">
				<bee-text-field 
					v-model="keywords" 
					context="statement" 
					:action-name="actions.GET" 
					:label="$t('AccountStatementPage.search-within-caption')"
					:hide-details="true" 
					@keydown-enter-prevent="search()"
				></bee-text-field>
			</v-col>
			<v-col cols="auto" lg="auto" md="auto" sm="6" class="pe-lg-0 d-flex flex-column">	
				<bee-date-picker
					context="statement" 
					:action-name="actions.GET" 
					:label="$t('AccountStatementPage.from-date')"
					v-model="start_date"
					class="ma-0 pa-0"
					:hide-details="true"
					@keydown-enter-prevent="search()"
				></bee-date-picker>
			</v-col>
			<v-col cols="auto" lg="auto" md="auto" sm="6" class="pe-lg-0 d-flex flex-column">
				<bee-date-picker
					context="statement" 
					:action-name="actions.GET" 
					class="ma-0 pa-0"
					:label="$t('AccountStatementPage.to-date')"
					v-model="end_date"
					:hide-details="true"
					@keydown-enter-prevent="search()"
				></bee-date-picker>
			</v-col>
			<v-col cols="auto" lg="auto" md="auto" sm="6" class="pe-lg-0 d-flex align-column">
				<bee-checkbox
					v-model="show_all_columns"
					:label="$t('AccountStatementPage.show-all-columns')"
					class="small-font-size mt-0"
				></bee-checkbox>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="auto" lg="auto" md="auto" sm="3" class="d-flex justify-end">
				<bee-btn  
					@click="search(); yearIndex = 0"
					:content="$t('AccountStatementPage.refresh')"
					color="blueGray"
					outer-class="mt-0 me-3"
					:loading="loading"
					context="statement" 
					:action-name="actions.GET"
				></bee-btn>
				<v-icon small color="grey" @click="cancel()" :loading="loading">fa-times-circle</v-icon>
			</v-col>
		</v-layout>
	</div>
	</div>
	<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
		<div v-if="routeNameIsMatchings">
			<router-view></router-view>
		</div>
		<v-card flat v-else>
		<v-card-text class="pt-0 px-3">
			<bee-simple-table
				:fixed-header="true" 
				class="statement"
				context="statement"
				:action-name="actions.GET" 
				ref="table"
				:with-color="false" :zebra="true" empty-state="dashes" :hide-footer="true" 
				:headers="showHeaders" 
				:items="advancedEntries" 
				:show-menu-actions="true"
				:right-click-menu-items="[{name: 'redirect', disabled: false, text: $t('AccountStatementPage.go-to-the-journal-of-entry'), action_name: actions.GET}, {name: 'matching', disabled: false, text: $t('AccountStatementPage.match'), action_name: actions.EDIT}]"
				:editable="false" :configs="configs"
				:highlighted-expression="(item)=>{return item.is_matched ? 'navPrimary' : item.is_balance_zero ? 'orangeLighten5' : ''}"
				@redirect="redirectToJournal($event)"
				@matching="dialogAccountMatching = true; updatedEntry = {...$event}"
			>
			</bee-simple-table>
			<template v-if="chartData.length">
				<div class="d-flex align-center my-2">
					<div dir="ltr">
						<v-btn
							color="primary"
							height="28"
							width="70"
							class="px-0 mr-2"
							:disabled="yearIndex === 0"
							@click="yearIndex--"
						>
							<v-icon size="20">mdi-menu-left</v-icon>
							{{chartYears[yearIndex-1] || chartYears[yearIndex]}}
						</v-btn>
						
						<v-btn
							color="primary"
							height="28"
							width="70"
							class="px-0"
							:disabled="yearIndex === chartYears.length - 1"
							@click="yearIndex++"
						>
							{{chartYears[yearIndex+1] || chartYears[yearIndex]}}
							<v-icon size="20">mdi-menu-right</v-icon>
						</v-btn>
					</div>
				
					<v-switch
						v-model="isStraightLine"
						dense
						append-icon="mdi-chart-line"
						hide-details
						class="ma-0 ms-3"
					/>
				</div>
				<v-row class="px-3 mt-3">
					<apexchart
						ref="apexchart"
						dir="ltr"
						class="flex-grow-1"
						type="line"
						height="350"
						:options="chartOptions"
						:series="[{ name: $t('AccountStatementPage.sum-result-headers.balance'), data: chartData }]"
					/>
				</v-row>
			</template>
		</v-card-text>
		</v-card>
		<bee-dialog
		    @handler="ChangeMatching()"
		    @close="dialogAccountMatching = false"
		    v-model="dialogAccountMatching"
		    :title="
				updatedEntry.is_matched
					? $t('AccountStatementPage.account-match')
					: $t('AccountStatementPage.account-unmatch')
			"
		    :message="
				updatedEntry.is_matched
				? $t('AccountStatementPage.are-you-sure-you-want-to-account-unmatch')
				: $t('AccountStatementPage.are-you-sure-you-want-to-account-match')
			"
		></bee-dialog>
	</div>
	<v-bottom-navigation
	id="footer"
    app
    class="px-3"
    horizontal
    background-color="#E1E2E4">
	<v-row align="center" justify="center" justify-lg="start">
		<v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
			<bee-outlined-header-info
			    border-color="transparent"
			    :head="$t('AccountStatementPage.balance')"
			    :column="false"
			>
				<template  v-slot:content="{}">
					<bee-advanced-money-label empty-state="_" v-model="sum_difference" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
				</template>
			</bee-outlined-header-info>
		</v-col>
		<v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex justify-start" v-if="show_symbol_currencies">
			<bee-outlined-header-info border-color="transparent" :head="$t('AccountStatementPage.currency-balances')" :column="false">
				<template  v-slot:content="{}">
					<bee-label empty-state="_" :content="currencies_sum_difference" :bold="true" color="grey"></bee-label>
				</template>
			</bee-outlined-header-info>
		</v-col>
		<v-spacer v-if="on_mdAndUp"></v-spacer>
		<v-col v-if="show_symbol_currencies" cols="auto" class="ma-0 pe-1 d-flex justify-lg-end justify-md-end justify-center">
		<v-menu v-model="showMoreDetails" top offset-y right transition="slide-y-transition" max-width="900" :close-on-click="false" :close-on-content-click="false">
			<template v-slot:activator="{ on }">
				<v-btn class="pe-0" depressed color="transparent" v-on="on" @click="showMoreDetails = !showMoreDetails"
					><v-icon class="mx-1">{{ showMoreDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon
					>{{$t('AccountStatementPage.more-details')}}</v-btn
				>
			</template>
			<v-card>
				<v-row align="center" class="ma-0 pa-3">
					<v-card-subtitle class="py-0 ps-0"> {{$t('AccountStatementPage.more-details')}}:</v-card-subtitle>
					<v-spacer></v-spacer>
					<v-btn icon @click="showMoreDetails = !showMoreDetails"><v-icon>mdi-close</v-icon></v-btn>
				</v-row>
				<v-row class="ma-0 pa-0" justify="center" align="center">
				<v-col cols="12" lg="6" class="d-flex justify-start align-center px-0 pt-0">
					<bee-outlined-header-info
					    border-color="transparent"
					    :head="$t('AccountStatementPage.sum-debit')"
					    :column="false"
					></bee-outlined-header-info>
					<v-card color="whiteBlue" style="width:75%">
						<v-card-text class="text-center">
							<bee-advanced-money-label empty-state="_" v-model="sum_debits" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" lg="6" class="d-flex justify-start align-center ps-0 pt-0">
					<bee-outlined-header-info
					    :column="false"
					    border-color="transparent"
					    :head="$t('AccountStatementPage.sum-credits')"
					></bee-outlined-header-info>
					<v-card color="whiteBlue" style="width:75%">
					<v-card-text class="text-center">
						<bee-advanced-money-label empty-state="_" v-model="sum_credits" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
					</v-card-text>
					</v-card>
				</v-col>
				</v-row>
				<v-row class="ma-0 pa-0" justify="center" align="center" v-if="show_symbol_currencies">
				<v-col cols="12" lg="6" class="d-flex justify-start align-center pt-0 px-0">
					<bee-outlined-header-info
					    border-color="transparent"
					    :head="$t('AccountStatementPage.currency-debits')"
					    :column="false"
					></bee-outlined-header-info>
					<v-card color="whiteBlue" style="width:75%">
					<v-card-text class="text-center">
						<bee-label empty-state="_" :content="currency_debits" color="red"  :bold="true"></bee-label>
					</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" lg="6" class="d-flex justify-start align-center pt-0 ps-0">
					<bee-outlined-header-info
					    border-color="transparent"
					    :head="$t('AccountStatementPage.currency-credits')"
					    :column="false"
					></bee-outlined-header-info>
					<v-card color="whiteBlue" style="width:75%">
					<v-card-text class="text-center">
						<bee-label empty-state="_" :content="currency_credits" color="green"  :bold="true"></bee-label>
					</v-card-text>
					</v-card>
				</v-col>
				</v-row>
			</v-card>
		</v-menu>
		</v-col>
		<v-col v-if="show_symbol_currencies" cols="auto" class="ma-0 pe-1 d-flex justify-lg-end justify-md-end justify-center">
		<v-menu v-model="showExchangeForm" top offset-y right transition="slide-y-transition" max-width="400" :close-on-click="false" :close-on-content-click="false">
			<template v-slot:activator="{ on }">
				<v-btn class="pe-0" depressed color="transparent" v-on="on" @click="showExchangeForm = !showExchangeForm"
					><v-icon class="mx-1">{{ showExchangeForm ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon
					>{{$t('AccountStatementPage.currency-equivalent')}}</v-btn
				>
			</template>
			<v-card>
				<v-card-text  class="py-1 px-2">
					<v-row align="center" class="ma-0 pa-0">
						<v-card-subtitle class="py-0">
							{{$t('AccountStatementPage.select-the-currency-to-display-the-equivalent-value')}}
						</v-card-subtitle>
						<v-spacer></v-spacer>
						<v-btn icon @click="showExchangeForm = !showExchangeForm"><v-icon>mdi-close</v-icon></v-btn>
					</v-row>
					<v-row  class="ma-0 pa-0">
						<v-col cols="12" lg="5" class="pe-lg-0">
							<bee-currencies-autocomplete   
								item-text="symbol"
                                :items="configs.currencies.filter(c=>c.id != configs.financial_file.default_currency_id) || []"
								v-model="sum_difference_equivalent.currency_id"
								@change="changeSumDifferenceEquivalent($event)"
                            ></bee-currencies-autocomplete>
						</v-col>
						<v-col class="px-lg-0">
							<bee-outlined-header-info border-color="transparent" :column="false">
								<template  v-slot:head="{}">
									<bee-advanced-money-label v-model="sum_difference_equivalent" :bold="true" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
								</template>
							</bee-outlined-header-info>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-menu>
		</v-col>
	</v-row>
    </v-bottom-navigation>
</div>
</template>
<script>
import  store  from "../../../store/index.js";
import {  mapState } from "vuex";
import actions from "../../../permissions/actions-names.js"
import ls from "../../../settings/localStorageExtension"
import moment from 'moment';
import { bondType } from '@/helpers/enums.js';
export default {
props: ['id'],
data: () => ({
	showExchangeForm: false,
	showMoreDetails: false,
	isStraightLine: false,
	yearIndex: 0,
	actions,
	routeNameIsMatchings: false,
	sum_difference_equivalent: { amount: null, currency_id: null, money_type: null},
	dialogAccountMatching: false,
	show_all_columns: false,
	includes_previous_balance: true,
	start_date: null,
	end_date: null,
	keywords: null,
	account_id: null,
	items: [],
	loading: false,

	chartArray: [],
	obj: {},
	updatedEntry: {is_matched: false},
}),
methods: {
	moment,
	goBack(){
		this.$router.go(-1)
	},
	cancel() {
		this.reSet()
		this.$router.push({ name: "account-statement" }).catch(()=>{})
	},
	redirectToJournal(entry){
		let routeData
		if(entry.is_cash)
			routeData = this.$router.resolve({name: 'cash-journal', params:{id: entry.bond_id}, query:{entryId: entry.id}});
		else
			routeData = this.$router.resolve({name: 'accounting-journal', params:{id: entry.bond_id}, query:{entryId: entry.id}});
		window.open(routeData.href, '_blank');
	},
	search(){
		if(this.account_id)
			{ 
				this.loading = true
				// this.$refs.table.openLoading();
				store.dispatch("statements/fetchAccountStatement", { 
					accountId: this.account_id, 
					start_date: this.start_date, 
					end_date: this.end_date, 
					keywords: this.keywords, 
					includes_previous_balance: this.includes_previous_balance
				})
				.then(()=>{
					this.$router.push({ name: "statement", params: { id: this.account_id }}).catch(()=>{})
				}).finally(()=>{ 
					this.loading = false
					this.sum_difference_equivalent = { amount: null, currency_id: null, money_type: null}
					/** this.$refs.table.closeLoading(); **/ 
				})
			}
	},
	reSet(){
		if(this.configs)
		{	
			this.start_date = this.configs.financial_file.start_date
			this.end_date = this.configs.financial_file.end_date ? this.configs.financial_file.end_date : new Date().toISOString()
		}
		else
		{
			this.start_date = new Date().toISOString().substr(0, 10)
			this.end_date = new Date().toISOString().substr(0, 10)
		}
		this.includes_previous_balance = true
		this.keywords = null
		this.account_id = null
		this.loading = false
		this.updatedEntry = { is_matched: false }
		this.$refs['BeeAutocomplete'].$refs.BeeAccountAutocomplete.$refs.BeeAutocomplete.focus()
		this.sum_difference_equivalent = { amount: null, currency_id: null, money_type: null}
	},
	changeSumDifferenceEquivalent(toCurrencyId) {
		if(toCurrencyId)
		{
			let sum_difference = this.accountStatementApi?.summary?.sum_result?.sum_difference
			if(sum_difference?.amount)
			{	
				let amount = sum_difference.amount
				let fromCurrecyId = sum_difference.currency_id
				store.dispatch("currencies/exchangeToCurrency",{ toCurrencyId, amount, fromCurrecyId })
					.then(response => {
						_.set(this.sum_difference_equivalent,"amount", response.amount)
						_.set(this.sum_difference_equivalent,"currency_id", response.currency_id)
						_.set(this.sum_difference_equivalent,"money_type", sum_difference.money_type)
					})
			}
		}
	},
	chart(){
		if(this.accountStatementApi)
		{
			if(this.accountStatementApi.chart_balance_data.length)
			{
				this.chartArray = this.accountStatementApi.chart_balance_data
				this.chartArray.unshift({date : '', money_amount:{ amount: 0, currency_id: null}})
				this.obj = {}
				this.chartArray.forEach(c => {
					_.set(this.obj, `${c.date}`, c.money_amount.amount)
				});
				return Object.entries(this.obj)
			}
			else{
				this.chartArray = []
				this.obj = {}
				return {}
			}
		}
		else 
			return {}
	},
	redirectToMatchingsPage(){
		this.$router.push({ name: "matchings", params: { id: Number(this.$route.params.id) } }).catch(()=>{})
	},
	ChangeMatching(){
		store.dispatch("statements/ChangeMatching", { bondType: this.updatedEntry.is_cash ? bondType.cash : bondType.accounting, bondId: this.updatedEntry.bond_id, entryId: this.updatedEntry.id, matching: this.updatedEntry.is_matched ? 'NotMatched' : 'Matched' })
	},

	exportAs(type, isBrief, isFromLatestMatching = false){
		// type value should be 'pdf' or 'excel'
		if (this.account_id){
			this.$store.dispatch('reports/RegularAccountStatement', {
				type,
				financialFileId: this.configs.financial_file.id,
				account_id: this.account_id,
				start_date: this.start_date,
				end_date: this.end_date,
				keywords: this.keywords,
				Includes_previous_balance: true,
				userId: ls.getLocalUser().id,
				brief: isBrief ? isBrief : false,
				fromLatestMatchingDate: isFromLatestMatching
			})
		}
	}
},
computed: {
	exportItems() {
		return [
			{
				text: this.$t('AccountStatementPage.export-as-excel'),
				icon: 'mdi-microsoft-excel',
				context: 'statement',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('AccountStatementPage.export-as-excel')+ ' ' + this.$t('AccountStatementPage.brief'),
				icon: 'mdi-microsoft-excel',
				context: 'statement',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('AccountStatementPage.print-account-statement'),
				icon: 'mdi-printer',
				context: 'statement',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('AccountStatementPage.print-account-statement')+ ' ' + this.$t('AccountStatementPage.brief'),
				icon: 'mdi-printer',
				context: 'statement',
				action_name: actions.EXPORT_AS_PDF
			},
		]
	},

	showHeaders(){
		return this.show_all_columns ? this.headers : this.subHeaders
	},
	...mapState("configs", ["configs"]),
	...mapState("statements", ["accountStatement"]),
	...mapState({
		currentFinancialFile: state => state.financialFiles.current_financial_file
	}),

	sum_result_headers() {
		return [
			{
				text: '',
				value: '1',
				type: '', 
				width: '10%'
			},
			{
				text: this.$t('AccountStatementPage.sum-result-headers.sum-debits'),
				value: 'sum_debits',
				type: 'money',
				width: '10%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountStatementPage.sum-result-headers.sum-credits'),
				value: 'sum_credits',
				type: 'money',
				width: '10%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountStatementPage.sum-result-headers.balance'),
				value: 'sum_difference',
				type: 'money',
				width: '15%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountStatementPage.sum-result-headers.equivalent-currency'),
				value: 'sum_difference_equivalent.currency_id',
				type: 'select',
				width: '10%'
			},
			{
				text: this.$t('AccountStatementPage.sum-result-headers.currency-equivalent'),
				value: 'sum_difference_equivalent',
				type: 'money',
				width: '15%',
				editable: true,
				settings:{ perspective: 'statement'} 
			},
			{
				text: this.$t('AccountStatementPage.sum-result-headers.currencies-balance'),
				value: 'currencies_sum_difference',
				type: 'string',
				width: '15%' 
			},
			{
				text: '',
				value: '5',
				type: '',
				width: '15%' 
			},
		]
	},

	sum_currencies_result_headers() {
		return [
			{ text: '', value: 'title', type: 'string', width: '21.5%' },
			{
				text: this.$t('AccountStatementPage.sum-currencies-result-headers.currency-debits'),
				value: 'currency_debits',
				type: 'string',
				width: '9%',
				editable: true
			},
			{
				text: this.$t('AccountStatementPage.sum-currencies-result-headers.currency-credits'),
				value: 'currency_credits',
				type: 'string',
				width: '9%',
				editable: true
			},
			{ text: '', value: '1', type: '', width: '44.5%', editable: true },
		]
	},

	headers(){
		return [
			{
				text: this.$t('AccountStatementPage.headers.balance'),
				value: 'balance',
				type: 'numeric',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.debit'),
				value: 'debit',
				type: 'money',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.credit'),
				value: 'credit',
				type: 'money',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.note'),
				value: 'note',
				type: 'string',
				width: '10%',
				editable: true},
			{
				text: this.$t('AccountStatementPage.headers.currency-debit'),
				value: 'currency_debit',
				type: 'money',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.currency-credit'),
				value: 'currency_credit',
				type: 'money',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.currency'),
				value: 'currency',
				type: 'currencies-autocomplete',
				width: '5%',
				editable: true,
				settings: { itemText: 'symbol' }
			},
			{
				text: this.$t('AccountStatementPage.headers.currency-price'),
				value: 'currency_price',
				type: 'numeric',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.currency-balances'),
				value: 'currency_balances',
				type: 'string',
				width: '10%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.paper-document-no'),
				value: 'paper_document_no',
				type: 'string',
				width: '5%',
				editable: true
			},
			{
				text: this.$t('AccountStatementPage.headers.date'),
				value: 'date',
				type: 'date',
				width: '10%',
				editable: true
			},
		]
	},

	subHeaders(){
		return [
			{
				text: this.$t('AccountStatementPage.headers.balance'),
				value: 'balance',
				type: 'numeric',
				width: '20%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.debit'),
				value: 'debit',
				type: 'money',
				width: '15%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.credit'),
				value: 'credit',
				type: 'money',
				width: '15%',
				editable: true,
				settings: { emptyState: 'none' }
			},
			{
				text: this.$t('AccountStatementPage.headers.note'),
				value: 'note',
				type: 'string',
				width: '35%',
				editable: true
			},
			{
				text: this.$t('AccountStatementPage.headers.date'),
				value: 'date',
				type: 'date',
				width: '15%',
				editable: true
			}
		]
	},
	
	chartYears() {
		const minYear = new Date(
			this.chartData.length
				? new Date(this.chartData[0][0])
				: this.currentFinancialFile.start_date
		).getFullYear();
		const maxYear = new Date(
			this.chartData.length
				? new Date(this.chartData[this.chartData.length - 1][0])
				: this.currentFinancialFile.end_date
		).getFullYear();
		
		const years = [];
		for (let year = minYear; year <= maxYear; year++) {
			years.push(year);
		}
		return years;
	},
	chartOptions() {
		const minDate = `${this.chartYears[this.yearIndex]}-01-01`;
		const maxDate = `${this.chartYears[this.yearIndex]}-12-31`;
		return {
			chart: {
				type: 'line',
				height: this.$vuetify.breakpoint.xlAndUp ? 350 : 240,
				toolbar: {
					show: true,
					tools: {
						download: false,
						pan: false,
						reset: '<span class="mdi mdi-chart-timeline" style="font-size: 20px"></span>',
						customIcons: [{	
							icon: '<span class="mdi mdi-home" style="font-size: 20px"></span>',
							index: -4,
							title: 'home',
							click: () => {
								this.$refs.apexchart.chart.zoomX(
									new Date(`${this.chartYears[this.yearIndex]}-01-01`).getTime(),
									new Date(`${this.chartYears[this.yearIndex]}-12-31`).getTime()
								)
							}
						}]
					},
				},
				autoSelected: 'pan', 
				zoom: { enabled: true }
			},
			tooltip: { enabled: true },
			dataLabels: {
				enabled: true,
				formatter: (val) => val.toLocaleString(),
				background: { enabled: true, borderRadius: 7, padding: 5 },
				offsetY: -8,
				style: {
					colors: [({series, dataPointIndex}) => series[0][dataPointIndex] < 0 ? '#e00c23' : '#02855b']
				},
			},
			colors: [this.$vuetify.theme.themes.light.primary],
			annotations: {
				xaxis: [{
					x: new Date().getTime(),
					borderColor: '#999',
					yAxisIndex: 0,
					label: { show: true, text: 'Today', style: { color: '#fff', background: '#775DD0' } }
				}]
			},
			xaxis: {
				type: 'datetime',
				min: new Date(minDate).getTime(),
				max: new Date(maxDate).getTime(),
				tickAmount: 12,
				tickPlacement: 'between',
				labels: {
					datetimeFormatter: { year: 'yyyy', month: 'MMM-yyyy', day: 'dd' }
				}
			},
			noData: { text: 'No data' },
			stroke: { curve: this.isStraightLine ? 'straight' : 'stepline' },
			markers: { size: 4 },
		}
	},
	chartData() {
		if (this.advancedEntries && this.advancedEntries.length) {
			return this.advancedEntries.map(c => ({
				date: moment(c.date).format('YYYY-MM-DD'),
				balance: c.balance
			})).reduce((result, a) => {
				const index = result.findIndex(c =>
					moment(c[0]).format('YYYY-MM') === moment(a.date).format('YYYY-MM')
				);
				if (index === -1) {
					result.push([a.date, a.balance]);
				} else {
					result[index][0] = a.date;
					result[index][1] = a.balance;
				}
				return result;
			}, [])
		}
		return [];
	},
	accountStatementApi() {
		return this.$route.params.id ? this.accountStatement : null
	},
	advancedEntries(){
		return this.accountStatementApi?.advanced_entries ? 
				this.accountStatementApi.advanced_entries
					.map(obj=> ( {...obj, 
						currency: obj.currency_credit ? obj.currency_credit.currency_id : (obj.currency_debit ? obj.currency_debit.currency_id : null),
						currency_balances: obj.previous_currencies_balance.length ? obj.previous_currencies_balance : obj.currency_balance
					})) 
				: []
	},
	file_is_locked(){
        return this.configs?.financial_file?.is_locked 
	},
	sum_result(){
		return  this.accountStatementApi?.summary ? [].concat({...Object.values(this.accountStatementApi?.summary)[1], sum_difference_equivalent: this.sum_difference_equivalent, currencies_sum_difference: this.accountStatementApi?.summary?.sum_currencies_result?.currencies_sum_difference}) : []
	},
	sum_difference(){ return this.accountStatementApi?.summary?.sum_result?.sum_difference || null },
	on_mdAndUp(){
		if(this.$vuetify.breakpoint.mdAndUp)
			return true
		return false;
	},
	show_symbol_currencies(){return ls.getVisibleSymbolMoney()},
	sum_debits(){ return this.accountStatementApi?.summary?.sum_result?.sum_debits || null },
	sum_credits(){ return this.accountStatementApi?.summary?.sum_result?.sum_credits || null },
	currency_debits(){ return this.accountStatementApi?.summary?.sum_currencies_result?.currency_debits || null },
	currency_credits(){ return this.accountStatementApi?.summary?.sum_currencies_result?.currency_credits || null },
	currencies_sum_difference(){ return this.accountStatementApi?.summary?.sum_currencies_result?.currencies_sum_difference || null },
},
mounted() { 
	window.observer.observe(document.querySelector("#tool-bar"))
	window.observer.observe(document.querySelector("#footer"))
	this.reSet()
	if(this.$route.params.id)
		this.account_id = this.accountStatement?.account.id
},
watch: {
	$route: function (to) {
		if(to.name == 'matchings')
			this.routeNameIsMatchings = true
		else
			this.routeNameIsMatchings = false
	}
},
async beforeRouteEnter(to, from, next) {
	let promises = []

	let object = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(object).length == 0)
		promises.push(store.dispatch("configs/fetchAll"))

	if (to.params.id && from.name != 'account-statement' && from.name != 'matchings') 
		promises.push(store.dispatch("statements/fetchAccountStatement", { accountId: to.params.id, start_date: null, end_date: null, keywords: null, includes_previous_balance: false }))
	
	if(promises.length)
		await Promise.all(promises)

	next();
}
};
</script>
<style scoped>
.small {
	max-width: 600px;
	margin:  150px auto;
}
.small-font-size .v-label { 
	font-size: 0.8rem !important;
	padding-right: 0px !important;
}
.my-border {
	border:1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>
<style>
.currencies-balances tr>td:nth-child(7) {
    direction: ltr;
}
.currencies-sum tr>td:nth-child(2) {
	direction: ltr;
}
.currencies-sum tr>td:nth-child(3) {
	direction: ltr;
}
.statement .bee-data-table tr>:nth-child(9) {
    direction: ltr;
}
</style>